import { Modal } from "antd";
import ServiceForm from "../Service/ServiceForm";

const UpdateServiceModal = ({ isOpen, onClose, serviceId, service }) => {
  return (
    <Modal
      title="Update Service"
      open={isOpen}
      onCancel={onClose}
      width={1000}
      footer={null}
      destroyOnHidden
    >
      <ServiceForm
        serviceId={serviceId}
        onClose={onClose}
        service={service}
        action="Update Service"
      />
    </Modal>
  );
};

export default UpdateServiceModal;
